import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import { Loading } from "components/UI";
import { useChurchStore } from "features/churches";
import { useDenominationStore } from "features/denominations";
import moment from "moment";
import { useAuthUser } from "react-auth-kit";
import { useParams, useSearchParams } from "react-router-dom";
import { useUserLogs } from "../api";

export const UserLogs = () => {
  const isOwnProfile = !location.pathname.includes("users");
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const selectedDenomination = useDenominationStore(
    state => state.selectedDenomination
  );
  const auth = useAuthUser();
  const { id } = useParams();

  const [searchParams] = useSearchParams();
  const denominationId = searchParams.get("denomination");

  const { data, isLoading } = useUserLogs({
    churchId: selectedChurch?.id,
    userId: isOwnProfile ? auth().id : id,
    isDenomination: !!denominationId,
    denominationId: denominationId
  });

  return (
    <Box
      sx={{
        overflow: "hidden"
      }}
    >
      <Box
        sx={{
          p: 2,
          backgroundColor: "secondary.main",
          color: "primary.main",
          fontWeight: 700
        }}
      >
        User Logs in{" "}
        {window.location.href.includes("denomination")
          ? selectedDenomination?.name
          : selectedChurch?.name}
      </Box>
      <Stack
        sx={{
          p: 1,
          backgroundColor: "neutral.main"
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">Action</TableCell>
              <TableCell align="center">Description</TableCell>
              <TableCell align="center">Date & Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell align="center" colSpan={3}>
                  <Stack alignItems="center" justifyContent="center">
                    <Loading size={20} />
                  </Stack>
                </TableCell>
              </TableRow>
            )}
            {!isLoading && data?.result?.data?.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={3}>
                  No logs
                </TableCell>
              </TableRow>
            )}
            {!isLoading &&
              data?.result?.data?.length > 0 &&
              data?.result?.data?.map(log => (
                <TableRow key={log.id}>
                  <TableCell>{log.event}</TableCell>
                  <TableCell>{log.description}</TableCell>
                  <TableCell>
                    {moment(log?.created_at).format("YYYY-MM-DD hh:mm:ss A")}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Stack>
    </Box>
  );
};
